// 智能体卡片共同业务逻辑 - 与UniApp版完全一致
export default {
	props: {
		agent: {
			type: Object,
			required: true
		},
		showActions: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		isOnline() {
			// 新API暂不支持在线状态，保留兼容性代码
			return this.agent.serviceStatus === 'online' || this.agent.isActive;
		},

		isAvailable() {
			// 新API返回的智能体都是可用的
			return true;
		},

		statusClass() {
			// 新API暂不支持在线状态，保留兼容性代码
			if (!this.agent.isActive) return 'status-inactive';
			if (this.agent.serviceStatus === 'online') return 'status-online';
			return 'status-offline';
		},

		statusText() {
			// 新API暂不支持在线状态，保留兼容性代码
			if (!this.agent.isActive) return '未激活';
			if (this.agent.serviceStatus === 'online') return '在线';
			return '离线';
		},
		
		serviceStatusText() {
			const statusMap = {
				'online': '在线',
				'offline': '离线',
				'starting': '启动中',
				'error': '错误'
			};
			return statusMap[this.agent.serviceStatus] || '未知';
		},
		
		modeText() {
			const modeMap = {
				'architect': '架构师',
				'developer': '开发者',
				'assistant': '助手',
				'analyzer': '分析师'
			};
			return modeMap[this.agent.mode] || this.agent.mode || '通用';
		},
		
		displayCapabilities() {
			const caps = [];
			if (this.agent.capabilities?.messageTypes?.includes('text')) caps.push('文本');
			if (this.agent.capabilities?.messageTypes?.includes('json')) caps.push('JSON');
			if (this.agent.capabilities?.taskTypes?.includes('execute')) caps.push('执行');
			return caps.slice(0, 3);
		}
	}
}